import { type RenderDetails, Vertex2, Vertex3 } from '@rta/rta-blueprint-library';

import { getVectorAngle } from './get-vector-angle';
import { type Vector, type VectorMetadata } from '@r-core/types';

export type ConvertPolyPoints2VectorsParams = Omit<RenderDetails, 'vertices'> & {
	vertices: Array<Vertex2 | Vertex3>,
	metadata?: VectorMetadata
};

export const convertPolyPoints2Vectors = ({ vertices, layer, metadata = {}}:ConvertPolyPoints2VectorsParams): Array<Vector<Vertex2>> => {
	const vectors: Array<Vector<Vertex2>> = [];

	// Cache all vertex coordinates FIRST to avoid issues with getters returning different values
	const cachedVertices = vertices.map((v) => (new Vertex2({ dataIn: { x: v.x, y: v.y }})));

	for (let i = 0; i < cachedVertices.length; i++) {
		const fromIdx = i;
		const toIdx = (i + 1) % cachedVertices.length; // Wrap around to close the loop

		// Use plain objects instead of Vertex2 to avoid getter issues
		const from = new Vertex2({ dataIn: { x: cachedVertices[fromIdx].x, y: cachedVertices[fromIdx].y }});
		const to = new Vertex2({ dataIn: { x: cachedVertices[toIdx].x, y: cachedVertices[toIdx].y }});
		const angle = getVectorAngle({ from, to });

		const vector: Vector<Vertex2> = { from, to, layer, angle, metadata };
		vectors.push(vector);
	}

	// console.log('convertPolyPoints2Vectors', vectors);
	return vectors;
};
